import { render, staticRenderFns } from "./ProductSearchFilter.vue?vue&type=template&id=5a36a6e3&scoped=true"
import script from "./ProductSearchFilter.vue?vue&type=script&lang=js"
export * from "./ProductSearchFilter.vue?vue&type=script&lang=js"
import style0 from "./ProductSearchFilter.vue?vue&type=style&index=0&id=5a36a6e3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a36a6e3",
  null
  
)

export default component.exports